import { forwardRef } from 'react';
import MuiCircularProgress from '@mui/material/CircularProgress';
import type { CircularProgressProps as MuiCircularProgressProps } from '@mui/material/CircularProgress';

/** Alias direto do MUI: nenhum default de aparência do projeto diverge do componente. */
export type CircularProgressProps = MuiCircularProgressProps;

/** Indicador de carregamento circular do design system: para carregamento de página/seção — dentro de um botão, ver o `loading` do `Componente_Button`. */
export const CircularProgress = forwardRef<HTMLSpanElement, CircularProgressProps>(
  function CircularProgress(props, ref) {
    return <MuiCircularProgress ref={ref} {...props} />;
  },
);
